import {
  blue,
  cyan,
  geekblue,
  gold,
  green,
  grey,
  lime,
  magenta,
  orange,
  purple,
  red,
  volcano,
  yellow
} from '@ant-design/colors'

const PREDEFINED_COLORS = [blue, cyan, geekblue, gold, green, grey, lime, magenta, orange, purple, red, volcano, yellow];

export function randomizeColors() {
  const randomItem = randomInArray(PREDEFINED_COLORS);
  if (randomItem.primary) return randomItem.primary;

  const randomColor = randomInArray(randomItem);
  return randomColor;
}

export function randomInArray<T>(array: T[]) {
  return array[Math.floor(Math.random() * array.length)];
}